import { Button } from './Button';

export interface Props {
  children: React.ReactNode;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  disable?: boolean;
}

export const CheckButton: React.FC<Props> = ({ children, isActive, className, onClick }) => {
  return (
    <Button className={className} variant={isActive ? 'primary' : 'secondary'} onClick={onClick}>
      {children}
    </Button>
  );
};
